import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { updateRouterParams } from '@redux/global/actions';
import * as globalSelectors from '@redux/global/selectors';
export * from './walmart';

const useUpdateRouterParams = () => {
  const routerParams = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (routerParams) {
      dispatch(updateRouterParams(routerParams));
    }

    return () => {
      dispatch(updateRouterParams({}));
    };
  }, [dispatch, routerParams]);
};

const useGetRouterParams = () => {
  const reduxRouterParams = useSelector(globalSelectors.selectRouterParams());

  return reduxRouterParams;
};

export { useUpdateRouterParams, useGetRouterParams };
export * from './walmart';
